<template>
  <v-ons-col>
    <v-ons-row class="color-chart-text">
      <v-ons-col :style="minColor">小さい</v-ons-col>
      <v-ons-col :style="maxColor">大きい</v-ons-col>
    </v-ons-row>
    <v-ons-row class="color-chart">
      <v-ons-col
        v-for="color in colors"
        :key="color"
        :style="{ background: color }"
        class="color"
      />
    </v-ons-row>

  </v-ons-col>
</template>

<script>
export default {
  data() {
    return {
      colors: [
        '#00a8c5',
        '#36d692',
        '#6bed00',
        '#ffa600',
        '#e80015',
      ],
    };
  },
  computed: {
    minColor: ({ colors }) => ({ color: colors[0] }),
    maxColor: ({ colors }) => ({ color: colors.slice(-1)[0] }),
  },
};
</script>



// WEBPACK FOOTER //
// sound.vue?624c1885